<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_18742_3557)">
            <path
                d="M4.66797 9.33341H3.1688C1.83297 9.33341 1.16797 8.66841 1.16797 7.33258V3.16758C1.16797 1.83175 1.83297 1.16675 3.1688 1.16675H5.83463C7.17047 1.16675 7.83547 1.83175 7.83547 3.16758"
                stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M10.8307 12.8334H8.1649C6.82906 12.8334 6.16406 12.1684 6.16406 10.8326V6.66758C6.16406 5.33175 6.82906 4.66675 8.1649 4.66675H10.8307C12.1666 4.66675 12.8316 5.33175 12.8316 6.66758V10.8326C12.8316 12.1684 12.1666 12.8334 10.8307 12.8334Z"
                stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.67578 8.75H10.5774" stroke="white" stroke-width="0.875" stroke-linecap="round"
                stroke-linejoin="round" />
            <path d="M9.625 9.70074V7.79907" stroke="white" stroke-width="0.875" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_18742_3557">
                <rect width="14" height="14" fill="white" />
            </clipPath>
        </defs>
    </svg>

</template>